var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-input',_vm._b({attrs:{"placeholder":_vm.placeholder,"addon-left-icon":_vm.leftIcon,"value":_vm.value,"id":"mapPlaces"},on:{"input":_vm.updateValue,"focus":function($event){return _vm.$emit('focus', $event)},"blur":function($event){return _vm.$emit('blur', $event)}}},'base-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }